import Payment from '@/Utils/payment'

export default {
  methods: {
    async payWithCard (config) {
      const gateway = 'Noon'
      const Pay = new Payment(gateway, config)
      const { url } = await Pay.paymentConfig()
      if (gateway.toLowerCase() === 'hyperpay') {
        this.hyperpayForm = true

        const optionsScript = document.createElement('script')
        optionsScript.innerHTML = 'var wpwlOptions={locale:"ar"}'
        document.body.appendChild(optionsScript)
        const script = document.createElement('script')
        script.src = url
        document.body.appendChild(script)
        const form = document.createElement('form')
        form.classList.add('paymentWidgets')
        form.setAttribute('data-brands', 'VISA MASTER AMEX')
        form.action = '/checkout/payment-status'
        document.querySelector('.hyperpay-form').appendChild(form)
      }
    }
  }
}
